import { createSlice } from "@reduxjs/toolkit";

interface loaderState {
  loaderValue: boolean;
}
export const initialState: loaderState = {
  loaderValue: false,
};

export const slice = createSlice({
  name: "loader",
  initialState,
  reducers: {
    setLoader: (state, action) => {
      const value = action.payload;
      state.loaderValue = value;
    },
  },
});

export const { setLoader } = slice.actions;

export default slice.reducer;
